import { render } from "./project-table.vue?vue&type=template&id=1cd3bb1a"
import script from "./project-table.vue?vue&type=script&lang=js"
export * from "./project-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__